import { render, staticRenderFns } from "./socialList.vue?vue&type=template&id=e3f82c74&scoped=true&"
import script from "./socialList.vue?vue&type=script&lang=js&"
export * from "./socialList.vue?vue&type=script&lang=js&"
import style0 from "./socialList.vue?vue&type=style&index=0&id=e3f82c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f82c74",
  null
  
)

export default component.exports